import { CONSTANTS } from "client/utils/constants";
import { useEffect, useState } from "react";
import RequestReasonDetailApprovalOrder from "./RequestReasonDetailApprovalOrder";
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { useDispatch, useSelector } from "react-redux";
import { setIsItemAndOrderLevelApproval } from "Store/OrderManagement/Approval/ApprovalAction"
import ApprovalDispatch from 'Store/OrderManagement/Approval/ApprovalDispatch';
import { setOrderApprovalRequest, setQuantityApprovalOption, setSelectedOptionsSubmit } from 'Store/Component/OrderApproval/OrderApprovalAction';

const RequestReasonDetailApprovalOrderContainer = (props?: any) => {
    let unPlannedItem = props?.unPlannedItem;
    let growthItem = props?.growthItem;
    let plannedItem = props?.plannedItem;
    let setDisableButton = props?.setDisableButton;
    let disableQuantityButton = props?.disableQuantityButton;
    let itemDetail = props?.itemDetail;
    let setQuantityLevelComments = props?.setQuantityLevelComments;
    let quantityLevelComments = props?.quantityLevelComments;

    const dispatch = useDispatch();

    const [quantityApproverActionList, setQuantityApproverActionList] = useState<any>([]);
    const dispatchGetApproverActionData = ApprovalDispatch.dispatchGetApproverActionData(dispatch);

    const {
        orderApprovalRequest,
        quantityApprovalOption,
        selectedOptionsSubmit,
        quantityApproverActionData
    }: any = useSelector((state: any) => ({
        orderApprovalRequest: state.OrderApprovalReducer.orderApprovalRequest,
        quantityApprovalOption: state.OrderApprovalReducer.quantityApprovalOption,
        selectedOptionsSubmit: state.OrderApprovalReducer.selectedOptionsSubmit,
        quantityApproverActionData: state.ApprovalReducer.quantityApproverActionData,
    }))

    let orderItem: any = [];
    
    if (plannedItem) {
        orderItem.push({ plannedItem })
    }
    if (growthItem) {
        orderItem.push({ growthItem })
    }
    if (unPlannedItem) {
        orderItem.push({ unPlannedItem })
    }
    useEffect(() => {
        dispatchGetApproverActionData("QuantityLevel");
        dispatch(setOrderApprovalRequest({
            orderId: 0,
            approverEmailId: '',
            approverActionId: 0,
            comment: '',
            requestApproveVMs: []
       }))
    }, [])
    useEffect(() => {
        if (quantityApproverActionData && quantityApproverActionData?.length > 0) {
            const newList: any = [];
            quantityApproverActionData?.forEach((item: any) => {
                switch (item.key) {
                    case "Request More Info":
                        newList[0] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsReturnToRequestor) || disableQuantityButton) };
                        break;
                    case "Approve":
                        newList[1] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsApprove) || disableQuantityButton) };
                        break;
                    case "Reject":
                        newList[2] = { ...item, disabled: (!isAuthorized(permissions.ApprovalsReject) || disableQuantityButton) };
                        break;
                    default:
                        break;
                }
            })
            setQuantityApproverActionList(newList);
        }
    }, [quantityApproverActionData, disableQuantityButton])

    const onRadioButtonChange = (e: any, value: any) => {
        setDisableButton(true);
        let quanityApprovalRequest = orderApprovalRequest;
        let commentValue = quantityLevelComments?.filter((item: any) => item?.reasonId === value?.reasonId);
        let growthReason: any = []
        let nonGrowthReason: any = []
        let growthReasonApproveVMs = { 'reasonId': 0, 'approverActionId': 0, 'comment': '' }
        let nonGrowthReasonApproveVMs = { 'reasonId': 0, 'approverActionId': 0, 'comment': '' }
        let arr: any = { 'requestId': 0, 'approverActionId': 0, 'comment': '', 'growthReasonApproveVMs': [], 'nonGrowthReasonApproveVMs': [] };

        if (value?.reasonType == CONSTANTS.REASON_GROWTH) {
            growthReasonApproveVMs['reasonId'] = value?.reasonId
            growthReasonApproveVMs['approverActionId'] = e?.currentTarget?.value
            growthReasonApproveVMs['comment'] = commentValue[0]?.comments || "";
            growthReason.push(growthReasonApproveVMs)
        } else if (value?.reasonType != CONSTANTS.REASON_GROWTH) {
            nonGrowthReasonApproveVMs['reasonId'] = value?.reasonId
            nonGrowthReasonApproveVMs['approverActionId'] = e?.currentTarget?.value
            nonGrowthReasonApproveVMs['comment'] = commentValue[0]?.comments || "";
            nonGrowthReason.push(nonGrowthReasonApproveVMs)
        }
        arr['requestId'] = value?.requestId;

        if (quanityApprovalRequest?.requestApproveVMs?.length) {
            for (let i = 0; i < quanityApprovalRequest?.requestApproveVMs?.length; i++) {
                if (quanityApprovalRequest?.requestApproveVMs[i].requestId == value?.requestId && quanityApprovalRequest?.requestApproveVMs[i].approverActionId != 0) {
                    quanityApprovalRequest?.requestApproveVMs.splice(i, 1);
                } else if (quanityApprovalRequest?.requestApproveVMs[i].requestId == value?.requestId && quanityApprovalRequest?.requestApproveVMs[i].approverActionId == 0) {
                    if (value?.reasonType == CONSTANTS.REASON_GROWTH && quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs?.length) {
                        for (let j = 0; j < quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs?.length; j++) {
                            if (quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs[j]?.reasonId == value?.reasonId) {
                                quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs?.splice(j, 1);
                            }
                        }
                    } else if (value?.reasonType != CONSTANTS.REASON_GROWTH && quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.length) {
                        for (let k = 0; k < quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.length; k++) {
                            if (quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs[k]?.reasonId == value?.reasonId) {
                                quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.splice(k, 1);
                            }
                        }
                    }
                }
            }
        }
        let selectedOptionsSubmitTemp = selectedOptionsSubmit?.filter((item: any) => item?.reasonId !== value?.reasonId)
        if ((commentValue[0]?.comments?.length && commentValue[0]?.comments?.length <= 500) || ((!commentValue[0]?.comments?.length || commentValue[0]?.comments?.length <= 500) && e?.currentTarget?.value == "1")) {
            dispatch(setSelectedOptionsSubmit([...selectedOptionsSubmitTemp, {
                requestId: value?.requestId,
                reasonId: value?.reasonId,
                approverActionId: e?.currentTarget?.value
            }]))
        } else {
            dispatch(setSelectedOptionsSubmit(selectedOptionsSubmitTemp))
        }
        let requestIdExist = quanityApprovalRequest?.requestApproveVMs?.length ? quanityApprovalRequest?.requestApproveVMs?.filter((item: any) => item?.requestId === value.requestId) : [];
        if (requestIdExist?.length) {
            for (let i = 0; i < quanityApprovalRequest?.requestApproveVMs?.length; i++) {
                if (value?.reasonType == CONSTANTS.REASON_GROWTH) {
                    if(quanityApprovalRequest?.requestApproveVMs[i]?.requestId == value?.requestId){
                    if (quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs?.length ) {
                        let growthItems: any = [...quanityApprovalRequest.requestApproveVMs[i].growthReasonApproveVMs]
                        growthItems = growthItems.filter((item: any) => item?.reasonId !== value.reasonId);
                        arr['growthReasonApproveVMs'] = [...growthItems, growthReasonApproveVMs]                  
                    } else {
                        arr['growthReasonApproveVMs'] = growthReason;
                    }
                    arr['requestId'] = value?.requestId
                    arr['approverActionId'] = 0
                    arr['comment'] = "";
                    arr['nonGrowthReasonApproveVMs'] = quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs
                }
                } else if (value?.reasonType != CONSTANTS.REASON_GROWTH) {
                    if(quanityApprovalRequest?.requestApproveVMs[i]?.requestId == value?.requestId){
                    if (quanityApprovalRequest?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.length ) {
                        let nonGrowthItems: any = [...quanityApprovalRequest.requestApproveVMs[i].nonGrowthReasonApproveVMs]
                        nonGrowthItems = nonGrowthItems.filter((item: any) => item?.reasonId !== value.reasonId);
                        arr['nonGrowthReasonApproveVMs'] = [...nonGrowthItems, nonGrowthReasonApproveVMs];
                    } else {
                        arr['nonGrowthReasonApproveVMs'] = nonGrowthReason
                    }
                    arr['requestId'] = value?.requestId
                    arr['approverActionId'] = 0
                    arr['comment'] = ""
                    arr['growthReasonApproveVMs'] = quanityApprovalRequest?.requestApproveVMs[i]?.growthReasonApproveVMs
                }
                   
                }
            }
        } else {
            arr['growthReasonApproveVMs'] = growthReason
            arr['requestId'] = value?.requestId
            arr['approverActionId'] = 0
            arr['comment'] = "";
            arr['nonGrowthReasonApproveVMs'] = nonGrowthReason
        }

        let requestItems = [...quanityApprovalRequest.requestApproveVMs]
        requestItems = requestItems.filter(item => item?.requestId !== arr.requestId);
        quanityApprovalRequest.requestApproveVMs = [...requestItems, arr];
        quanityApprovalRequest.approverActionId = 0
        quanityApprovalRequest.comment = ''
        dispatch(setIsItemAndOrderLevelApproval(null))
        dispatch(setOrderApprovalRequest(quanityApprovalRequest))
        let selectedQuantityOptionTemp = [...quantityApprovalOption];
        selectedQuantityOptionTemp = selectedQuantityOptionTemp?.filter((item: any) => item?.reasonId !== value?.reasonId);
        dispatch(setQuantityApprovalOption([...selectedQuantityOptionTemp, {
            requestId: value?.requestId,
            reasonId: value.reasonId,
            selectedOption: e?.currentTarget?.value != "1" ? e?.currentTarget?.value != "2" ? "Request More Info" : "Reject" : "Approve",
            commentRequiredError: e?.currentTarget?.value != "1" && !commentValue[0]?.comments?.length ? true : false
        }]))
    }

    const onCommentChange = (e?: any, value?: any) => {
        let orderApprovalRequestTemp = orderApprovalRequest;
        if (orderApprovalRequestTemp?.requestApproveVMs?.length) {
            for (let i = 0; i < orderApprovalRequestTemp?.requestApproveVMs?.length; i++) {
                if (orderApprovalRequestTemp?.requestApproveVMs[i].requestId == value?.requestId && orderApprovalRequestTemp?.requestApproveVMs[i].approverActionId == 0) {
                    if (value?.reasonType == CONSTANTS.REASON_GROWTH && orderApprovalRequestTemp?.requestApproveVMs[i]?.growthReasonApproveVMs?.length) {
                        for (let j = 0; j < orderApprovalRequestTemp?.requestApproveVMs[i]?.growthReasonApproveVMs?.length; j++) {
                            if (orderApprovalRequestTemp?.requestApproveVMs[i]?.growthReasonApproveVMs[j]?.reasonId == value?.reasonId) {
                                orderApprovalRequestTemp.requestApproveVMs[i].growthReasonApproveVMs[j].comment = e?.currentTarget?.value
                            }
                        }
                    } else if (value?.reasonType != CONSTANTS.REASON_GROWTH && orderApprovalRequestTemp?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.length) {
                        for (let k = 0; k < orderApprovalRequestTemp?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs?.length; k++) {
                            if (orderApprovalRequestTemp?.requestApproveVMs[i]?.nonGrowthReasonApproveVMs[k]?.reasonId == value?.reasonId) {
                                orderApprovalRequestTemp.requestApproveVMs[i].nonGrowthReasonApproveVMs[k].comment = e?.currentTarget?.value
                            }
                        }
                    }
                }
            }
        }
        dispatch(setOrderApprovalRequest(orderApprovalRequestTemp))

        let selectedQuantityOptionTemp = [...quantityApprovalOption];
        selectedQuantityOptionTemp = selectedQuantityOptionTemp?.filter((item: any) => item?.reasonId == value?.reasonId);
        let approverActionIdTemp = selectedQuantityOptionTemp[0]?.selectedOption != "Approve" ? selectedQuantityOptionTemp[0]?.selectedOption == "Reject" ? "2" : "3" : "1"
        let quantityApprovalOptionTemp = quantityApprovalOption
        if (quantityApprovalOption?.length) {
            for (let x = 0; x < quantityApprovalOptionTemp?.length; x++) {
                if (quantityApprovalOptionTemp[x]?.reasonId == value?.reasonId) {
                    let selectedOptionsSubmitTemp = selectedOptionsSubmit?.length ? selectedOptionsSubmit?.filter((item: any) => item?.reasonId !== value?.reasonId) : []
                    if (e?.currentTarget?.value?.length && e?.currentTarget?.value?.length <= 500) {
                        dispatch(setSelectedOptionsSubmit([...selectedOptionsSubmitTemp, {
                            requestId: value?.requestId,
                            reasonId: value?.reasonId,
                            approverActionId: approverActionIdTemp ? approverActionIdTemp : 0
                        }]))
                    } else {
                        dispatch(setSelectedOptionsSubmit(selectedOptionsSubmitTemp))
                    }
                    if (e?.currentTarget?.value?.length) {
                        quantityApprovalOptionTemp[x].commentRequiredError = false
                    } else {
                        quantityApprovalOptionTemp[x].commentRequiredError = true
                    }
                }
            }
        }
        dispatch(setQuantityApprovalOption(quantityApprovalOptionTemp))

        let quanityLevelCommentsTemp = [...quantityLevelComments];
        quanityLevelCommentsTemp = quanityLevelCommentsTemp?.filter((item: any) => item?.reasonId !== value?.reasonId);
        setQuantityLevelComments([...quanityLevelCommentsTemp, {
            requestId: value?.requestId,
            reasonId: value.reasonId,
            comments: e?.currentTarget?.value,
            commentLengthError: (e?.currentTarget?.value?.length > 500)
        }])
    }

    const getQuantityLevelValue = (itemVal?: any, action?: any) => {
        if (action == "comment") {
            let quanityLevelCommentsTemp = quantityLevelComments?.filter((item: any) => item?.reasonId === itemVal?.reasonId);
            return (quanityLevelCommentsTemp?.length ? quanityLevelCommentsTemp[0]?.comments : "")
        } else if (action == "selectedOption") {
            let selectedQuantityOptionTemp = quantityApprovalOption?.filter((item: any) => item?.reasonId === itemVal?.reasonId);
            return (selectedQuantityOptionTemp?.length ? selectedQuantityOptionTemp[0]?.selectedOption : "")
        } else if (action == "lengthError") {
            let quanityLevelCommentsTemp = quantityLevelComments?.filter((item: any) => item?.reasonId === itemVal?.reasonId);
            return (quanityLevelCommentsTemp?.length ? quanityLevelCommentsTemp[0]?.commentLengthError : "")
        } else if (action == "requiredError") {
            let selectedQuantityOptionTemp = quantityApprovalOption?.filter((item: any) => item?.reasonId === itemVal?.reasonId);
            return (selectedQuantityOptionTemp?.length ? selectedQuantityOptionTemp[0]?.commentRequiredError : "")
        }
    }

    const getQuantityCardStyle = (quantityItem: any) => {
        let selectedQuantityOptionTemp = quantityApprovalOption?.filter((item: any) => item?.reasonId === quantityItem?.reasonId);
        return (selectedQuantityOptionTemp?.length ? selectedQuantityOptionTemp[0]?.selectedOption : "")
    };

    return (
        <RequestReasonDetailApprovalOrder
            unPlannedItem={unPlannedItem}
            growthItem={growthItem}
            plannedItem={plannedItem}
            orderItem={orderItem}
            onRadioButtonChange={onRadioButtonChange}
            quantityApproverActionList={quantityApproverActionList}
            itemDetail={itemDetail}
            disableQuantityButton={disableQuantityButton}
            getQuantityCardStyle={getQuantityCardStyle}
            onCommentChange={onCommentChange}
            getQuantityLevelValue={getQuantityLevelValue}
            isBulkOrder={props?.isBulkOrder}
        />
    )
}
export default RequestReasonDetailApprovalOrderContainer